import React, { createContext, useContext } from 'react';

/**
 * Context for the first pane in SplitView
 * Provides dimensions and state information to children
 */
export const FirstPaneContext = createContext({
  width: 0,
  height: 0,
  isCollapsible: false,
  isResizable: true,
  isCollapsed: false,
  isResized: false,
  hidePane: () => { },
  showPane: () => { },
  hideDivider: () => { },
  showDivider: () => { },
});

/**
 * Context for the second pane in SplitView
 * Provides dimensions and state information to children
 */
export const SecondPaneContext = createContext({
  width: 0,
  height: 0,
  isCollapsible: false,
  isResizable: true,
  isCollapsed: false,
  isResized: false,
  hidePane: () => { },
  showPane: () => { },
  hideDivider: () => { },
  showDivider: () => { },
});

/**
 * Hook to access the first pane context
 * @returns {Object} First pane context values
 */
export const useFirstPaneContext = () => useContext(FirstPaneContext);

/**
 * Hook to access the second pane context
 * @returns {Object} Second pane context values
 */
export const useSecondPaneContext = () => useContext(SecondPaneContext);
